import Phaser from "phaser";
import { FIRE_TILE_DAMAGE, TILE_SIZE } from "../config";
import { SPRITE_FRAMES, SPRITESHEET_KEY, SPRITESHEET_TILE } from "../sprites";

const FIRE_SCALE = TILE_SIZE / SPRITESHEET_TILE;

/**
 * Damaging environmental tile, scattered at map start. Doesn't block movement
 * — you walk into one, it damages you, and stays put.
 */
export class FireTile {
  readonly col: number;
  readonly row: number;
  readonly damage: number = FIRE_TILE_DAMAGE;
  readonly sprite: Phaser.GameObjects.Sprite;

  constructor(scene: Phaser.Scene, col: number, row: number) {
    this.col = col;
    this.row = row;
    this.sprite = scene.add.sprite(
      col * TILE_SIZE + TILE_SIZE / 2,
      row * TILE_SIZE + TILE_SIZE / 2,
      SPRITESHEET_KEY,
      SPRITE_FRAMES.fireTile,
    );
    this.sprite.setScale(FIRE_SCALE);
    this.sprite.setDepth(5);

    // Per-tile flicker so the map doesn't look static.
    scene.tweens.add({
      targets: this.sprite,
      alpha: { from: 0.7, to: 1 },
      duration: 180 + Math.random() * 240,
      yoyo: true,
      repeat: -1,
    });
  }
}
